import React from "react"
import PropTypes from "prop-types"
import { getCompiler } from "utils/MarkdownCompile"
import { Body } from "./atoms/Bodies"
import { TextLink } from "./atoms/links/TextLink"
import { elements } from "./DefaultMarkdown"
import { H2, H5 } from "@carrotfertility/carotene"
import { ZendeskTextLink } from "./atoms/links/ZendeskTextLink"
import { isZendeskLink } from "carrot-api/HelpCenterClient"

const newElements = {
  ...elements,
  h2({ children }) {
    return (
      <div className="mt4">
        <H2>{children}</H2>
      </div>
    )
  },
  h3({ children }) {
    return <h3 className="lh-title mt4 mb0 black-90">{children}</h3>
  },
  h4({ children }) {
    return <h4 className="lh-title mt4 mb0 black-60">{children}</h4>
  },
  strong({ children }) {
    return <H5>{children}</H5>
  },
  // ,
  hr() {
    return <hr className="w5-ns w4 mv4 center b--black-05" />
  },
  // ol({ children }) {},
  ul({ children }) {
    return <ul className="lh-copy">{children}</ul>
  },
  li({ children }) {
    return (
      <li className="lh-copy mv1" style={{ fontSize: "14px" }}>
        {children}
      </li>
    )
  },
  p({ children }) {
    return <Body color="black-80">{children}</Body>
  },
  a({ href, title, target, children }) {
    if (isZendeskLink(href)) {
      return (
        <ZendeskTextLink target={target} title={title} to={href}>
          {children}
        </ZendeskTextLink>
      )
    }

    return (
      <TextLink href={href} title={title} target={target}>
        {children}
      </TextLink>
    )
  },
  table({ children }) {
    return (
      <div className="overflow-x-auto">
        <table className="f5 v-top w-100 min-w65 t--fixed collapse pv2 ph3 ba --moon-gray bg-black-05">
          {children}
        </table>
      </div>
    )
  },
  th({ children }) {
    return <th className="v-btm collapse pv2 ph3 ba b--moon-gray striped--pearl-lusta">{children}</th>
  },
  td({ children }) {
    return <td className="v-top collapse pv2 ph3 ba b--moon-gray striped--pearl-lusta">{children}</td>
  }
}

const md = getCompiler(newElements)

const AccordionMarkdown = ({ additionalClasses, source }) => (
  <div className={`mt1-first-child mb0-last-child ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
)

AccordionMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  additionalClasses: PropTypes.string
}

export default AccordionMarkdown
